import { IconButton, Text } from '@ui'
import React from 'react'
import { IconType } from 'react-icons'
import { useNavigate } from 'react-router-dom'

export interface IActionButtonProps {
  onClick?: () => void
  route?: string
  icon: IconType
  label: string
  /** At most one action per row is primary. */
  primary?: boolean
}

export const ActionButton = ({
  onClick,
  route,
  icon: Icon,
  label,
  primary,
}: IActionButtonProps) => {
  const navigate = useNavigate()

  const handleOnClick = () => {
    if (onClick) {
      onClick()
    } else if (route) {
      navigate(route)
    }
  }

  return (
    <div className="flex min-w-0 flex-1 flex-col items-center gap-2">
      <IconButton
        aria-label={label}
        variant={primary ? 'primary' : 'secondary'}
        size="lg"
        className="size-14 text-[24px]"
        onClick={handleOnClick}
      >
        <Icon aria-hidden="true" />
      </IconButton>
      <Text as="span" variant="label" tone="fg-2" aria-hidden="true">
        {label}
      </Text>
    </div>
  )
}
